/**
 * ShareConfig
 */

const Config = {
  nodeId: "#ncShare",
  title: document.title ? document.title : "",
  desc: document.querySelector('meta[name^="description"]')
    ? document.querySelector('meta[name^="description"]').content
    : "",
  image: document.querySelector('meta[property^="og:image"]')
    ? document.querySelector('meta[property^="og:image"]').content
    : "",
  location: window.location.href,
};

export default Config